import flattenTranslations from '@/components/translations/flattenTranslations';
import common from '@/components/translations/da/common';
import home from '@/components/translations/da/Home';
import elaftale from '@/components/translations/da/Elaftale';
import smartCharge from '@/components/translations/da/SmartCharge';
import opladere from '@/components/translations/da/Opladere';
import solar from '@/components/translations/da/Solcelleaftale';
import faqPage from '@/components/translations/da/FAQ';
import kontakt from '@/components/translations/da/Kontakt';
import blogPage from '@/components/translations/da/Blog';
import gebyrer from '@/components/translations/da/Gebyrer';
import chargers from '@/components/translations/da/chargers';
import infoPages from '@/components/translations/da/infoPages';
import legal from '@/components/translations/da/legal';
import widgets from '@/components/translations/da/widgets';
import pricePage from '@/components/translations/da/pricePage';
import comparePrices from '@/components/translations/da/comparePrices';
import nicolasKj from '@/components/translations/da/nicolasKj';
import testFrontpage from '@/components/translations/da/testFrontpage';
import marketingHardcoded from '@/components/translations/da/marketingHardcoded';
import pioneers from '@/components/translations/da/pioneers';
import understandBill from '@/components/translations/da-understandBill';

export default {
  ...flattenTranslations(common), home, elaftale, smartCharge, opladere,
  solar, testFrontpage, faqPage, kontakt, blogPage, gebyrer, chargers,
  infoPages, legal, widgets, pricePage, comparePrices, nicolasKj,
  marketingHardcoded, pioneers, understandBill,
};